import React, { useEffect, useMemo, useRef } from 'react';
import { StyleSheet, View } from 'react-native';
import Indicator from 'design-system/Indicator';
import { AppView } from 'design-system/AppView';
import Code404Card from 'design-system/Code404Card';
import { useAppSelector } from 'store/hooks';
import { getTransaction } from 'actions/transactions';
import useFetchOld, { muteErrorAndResult } from 'hooks/useFetch';
import { selectIncludeIncomeSubscriptions } from 'features/subscriptions/selectors';
import { isWeb } from '../../../constants';
import { makeSelectTransactionById } from '../selectors';
/**
 *
 * This hook tries to select transaction from transactionId
 * If transaction doesnt exist in reducer, it tries to get the transaction using transactionId
 *
 */
export const useTransaction = (transactionId) => {
    const [, , requesting, fetch] = useFetchOld(muteErrorAndResult);
    const memoSelectTransactionById = useMemo(makeSelectTransactionById, []);
    const transaction = useAppSelector((store) => memoSelectTransactionById(store, transactionId));
    const isInitialTransactionDefinedRef = useRef(!!transaction);
    const includeIncome = useAppSelector(selectIncludeIncomeSubscriptions);
    useEffect(() => {
        if (!transaction && transactionId) {
            fetch(getTransaction(transactionId, includeIncome));
        }
    }, [transaction, transactionId, includeIncome]);
    const LoadingOr404 = useMemo(() => (<AppView isInTab={isWeb} avoidHeader>
        {requesting ? (<View style={styles.indicatorContainer}>
            <Indicator dark/>
          </View>) : (<Code404Card />)}
      </AppView>), [requesting]);
    return {
        transaction,
        LoadingOr404,
        isInitialTransactionDefinedRef,
    };
};
const styles = StyleSheet.create({
    indicatorContainer: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
});
